import { PropTypes } from 'preact-compat';
import { createSelector } from 'reselect';
import { actionTypes } from '../actions';
import { OS } from '../utils/consts';

export const moduleName = 'application';

export const detectedShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  os: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
});

// Reducer (down)

/**
 *
 * @type {{
 * initialised: boolean,
 * initialising: boolean,
 * isUnsupportedMobileOs: boolean,
 * launchData: null | {
 *   activeNowBadgeTime: number,
 *   callTimeFree: number,
 *   callTimeBeep: number,
 *   minWithdrawalAmount: number,
 *   userSupportId: number,
 *   systemFeePayout: null | { amount: number, percent: number }[]
 * },
 * detected: Object | null,
 * error: string
 * }}
 */
const initialState = {
  initialised: false,
  initialising: false,
  isUnsupportedMobileOs: false,
  isWebview: false,
  error: '',
  detected: null,
  launchData: null,
  applicationShouldUpdate: false,
};

export default (state = initialState, action) => {
  const { error, type, payload } = action;

  switch (type) {
    case actionTypes.APPLICATION_INITIALISE_REQUEST:
      return {
        ...state,
        initialised: false,
        initialising: true,
        error: initialState.error,
        launchData: initialState.launchData,
      };

    case actionTypes.APPLICATION_INITIALISE_SUCCESS: {
      const { launchData } = payload;

      return {
        ...state,
        launchData,
        initialised: true,
        initialising: false,
        error: initialState.error,
      };
    }

    case actionTypes.APPLICATION_INITIALISE_FAILURE:
      return {
        ...state,
        initialised: false,
        initialising: false,
        error: error || 'Unknown initialisation error',
      };

    case actionTypes.APPLICATION_SET_DETECTED: {
      const { isWebview, detected } = payload;

      const { os } = detected;

      return {
        ...state,
        isWebview,
        detected,
        isUnsupportedMobileOs: [OS.ANDROID, OS.IOS].includes(os),
      };
    }

    case actionTypes.SET_APPLICATION_SHOULD_UPDATE_SUCCESS: {
      return {
        ...state,
        applicationShouldUpdate: payload,
      };
    }

    case actionTypes.SET_APPLICATION_SHOULD_UPDATE_FAILURE: {
      return {
        ...state,
        applicationShouldUpdate: false,
        error: error || 'Unknown error',
      };
    }

    default:
      return state;
  }
};

// Reducer (up)

// Selectors (down)

const stateSelector = (state) => state[moduleName];

export const selectApplicationIsInitialised = createSelector(
  stateSelector, (application) => application.initialised,
);

export const selectIsUnsupportedMobileOs = createSelector(
  stateSelector, (application) => application.isUnsupportedMobileOs,
);

export const selectApplicationIsWebview = createSelector(
  stateSelector, (application) => application.isWebview,
);

export const selectApplicationDetected = createSelector(
  stateSelector, (application) => application.detected,
);

export const selectApplicationLaunchData = createSelector(
  stateSelector, (application) => application.launchData,
);

export const selectApplicationActiveNowBadgeTime = createSelector(
  selectApplicationLaunchData,
  (launchData) => launchData && launchData.activeNowBadgeTime,
);

export const selectApplicationCallTimeBeep = createSelector(
  selectApplicationLaunchData,
  (launchData) => launchData && launchData.callTimeBeep,
);

export const selectApplicationCallTimeBeepDelay = createSelector(
  selectApplicationLaunchData,
  (launchData) => launchData && launchData.callTimeBeepDelay,
);

export const selectApplicationCallTimeFree = createSelector(
  selectApplicationLaunchData,
  (launchData) => launchData && launchData.callTimeFree,
);

export const selectApplicationMinWithdrawalAmount = createSelector(
  selectApplicationLaunchData,
  (launchData) => launchData && launchData.minWithdrawalAmount,
);

export const selectApplicationSystemFeePayout = createSelector(
  selectApplicationLaunchData,
  (launchData) => launchData && launchData.systemFeePayout,
);

export const selectApplicationUserSupportId = createSelector(
  selectApplicationLaunchData,
  (launchData) => launchData && launchData.userSupportId,
);

// Selectors (up)



// WEBPACK FOOTER //
// ./reducers/application.js